<div class="ep_new_tiles_cont {{ extraContainerClasses }}">
  <div class="ep_new_tiles_wrap {{ extraButtonClasses }}">
    @for (button of buttons; track button; let i = $index) {
      @if (!button.hidden) {
        <div
          class="ep_new_single_tile_wrap"
          [ngClass]="[inRow === 4 ? 'is-one-quarter' : 'is-half', isMarginOpenedInRow(i) ? 'margin-big' : '']"
          [class.hasError]="button.hasError"
          >
          @if (button.message) {
            <app-more-info-tooltip
              class="button-tooltip"
              [message]="button.message"
              [tileTooltipMobile]="true"
              [additionalDeductions]="true"
            ></app-more-info-tooltip>
          }
          @if (button.deleteAction && button.isSelected(buttonsData)) {
            <button
              mat-icon-button
              class="button-delete"
              (click)="button.deleteAction(button)"
              >
              <span></span>
            </button>
          }
          <button
            class="ep_new_single_tile"
            [class.bottom-straight]="button.extenderActive"
            [class.is-loading]="button.isLoading"
            [style.border]="button.hasError ? '1px solid red' : ''"
            [class.isRed]="button.hasError"
            (click)="button.clickAction(buttonsData, button)"
            [class.selected]="button.isSelected(buttonsData)"
            [class.active]="button.isSelected(buttonsData)"
            [id]="button.currentId || ''"
            >
            <div class="ep_desc_wrap">
              <div class="icon_tile_wrap">
                @if (button.imageSrc) {
                  <img class="icon_tile" [src]="button.imageSrc" />
                }
                @if (button.imageSrcAction) {
                  <img class="icon_tile" [src]="button.imageSrcAction(buttonsData)" />
                }
              </div>
              <div class="title-section">
                <span class="title_tile_sm" [innerHTML]="button.label | translate"></span>
                @if (button.description) {
                  <span class="description" [innerHTML]="button.description | translate"></span>
                }
              </div>
            </div>
          </button>
          @if (!button.extenderActive) {
            <div class="info-extender hidden"></div>
          }
          @if (button.extenderActive) {
            <div class="info-extender">
              <div class="level">
                @if (button.textTop) {
                  <div class="message-top level-left">{{ button.textTop | translate }} </div>
                }
                @if (button.extenderMessage) {
                  <div class="level-right">
                    <app-more-info-tooltip
                      [tileTooltipMobile]="true"
                      [message]="button.extenderMessage"
                      [sellect_button]="mit_sellect_button_style"
                      [questionMark]="true"
                      [additionalDeductions]="true"
                    ></app-more-info-tooltip>
                  </div>
                }
              </div>
            </div>
          }
          @if (button.goToAction && button.isSelected(buttonsData)) {
            <a
              (click)="button.goToAction(buttonsData)"
              class="select-section__picker"
              [class.extender-opened]="button.extenderActive"
              >
              {{ "COMMON.GO_TO" | translate }}<img src="../../../assets/img/gotoimg.png" />
            </a>
          }
        </div>
      }
    }
  </div>
</div>
